<template>
<div class="type_container">
    <div class="itemContainer" :class="{ itemSelected: item.recentType === recentType }" v-for="item in recentTypes" :key="item.recentType" v-on:mouseenter="selectRecentType(item)" @click="clickRecentType(item)">
      <svg-icon :icon-class="item.icon_name" class-name="icon"></svg-icon>
      <div class="title">{{ item.title }}</div>
    </div>
    <div class="title_line">{{$t("按归属#!!!#src/pages/H5/Cloud/components/hoverDir/RecentTypeView.vue_1")}}    </div>
    <div class="itemContainer" :class="{ itemSelected: item.recentType === recentType }" v-for="item in otherTypes" :key="item.recentType" v-on:mouseenter="selectRecentType(item)" @click="clickRecentType(item)">
      <svg-icon :icon-class="item.icon_name" class-name="icon"></svg-icon>
      <div class="title">{{ item.title }}</div>
    </div>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { mapActions, mapState } from "vuex";

export default {
  name: "RecentTypeView",
  data() {
    return {
      recentTypes: [
      {
        icon_name: "recent_type_home",
        title: intl.$t("首页#!!!#src/pages/H5/Cloud/components/hoverDir/RecentTypeView.vue_1"),
        recentType: 1
      },
      {
        icon_name: "recent_type_star",
        title: intl.$t("收藏#!!!#src/pages/H5/Cloud/components/hoverDir/RecentTypeView.vue_1"),
        recentType: 4
      }],

      otherTypes: [
      {
        icon_name: "recent_type_mine",
        title: intl.$t("我的文档#!!!#src/pages/H5/Cloud/components/hoverDir/RecentTypeView.vue_1"),
        recentType: 2
      },
      {
        icon_name: "recent_type_kb",
        title: intl.$t("知识库#!!!#src/pages/H5/Cloud/components/hoverDir/RecentTypeView.vue_1"),
        recentType: 3
      }]

    };
  },
  computed: {
    ...mapState({
      recentType: (state) => state.curSelectRecentType
    })
  },
  methods: {
    ...mapActions({
      setCurSelectRecentType: "setCurSelectRecentType"
    }),
    selectRecentType(item) {
      this.setCurSelectRecentType(item.recentType);
    },
    clickRecentType(item) {
      let baseURL = process.env.VUE_APP_WIKI_URL;
      switch (item.recentType) {
        case 1:
          window.open(`https:${baseURL}`, "_blank");
          break;
        case 2:
          window.open(`https:${baseURL}#my`, "_blank");
          break;
        case 3:
          window.open(`https:${baseURL}#wiki`, "_blank");
          break;
        case 4:
          window.open(`https:${baseURL}#star`, "_blank");
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.type_container {
  width: 162px !important;
  // height: 100% !important;
  padding: 12px 8px 8px 8px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-right: 1px solid #e6e8ec;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .title_line {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #a2a4b0;
    letter-spacing: 0;
    line-height: 17px;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .title_line:hover {
    color: #a2a4b0;
  }
}

.itemContainer {
  border-radius: 8px;
  width: 146px;
  height: 36px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;

  &:hover {
    background-color: #f4f6f9;
  }

  .icon {
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }

  .title {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #222329;
    margin-left: 8px;
    cursor: pointer;
  }
}

.itemSelected {
  background-color: #f4f6f9;
}
</style>
